function buildPlaybookFeedbackUrl(params) {
  const search = new URLSearchParams({
    selectionId: params.nodeId,
    feedbackId: params.feedbackId
  });
  return `/settings/playbooks/${encodeURIComponent(params.playbookId)}/feedback?${search.toString()}`;
}
export {
  buildPlaybookFeedbackUrl
};
//# sourceMappingURL=playbookFeedbackUrl.js.map
